import {RootState} from '../rootReducer';

export const scenarioSelector = (state: RootState) => state.scenario;
